import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../components/global/DynamicIcon";
import dataUtils from "../../../../../../common/utils/dataUtils";

type Props = {
  onActionEditar: (id: number | null, openState: boolean) => void;
  onActionDeletar: (id: number | null, openState: boolean) => void;
};

export const GenerateRevisaoResumoColumnDefinition = ({ onActionEditar, onActionDeletar }: Props): GridColDef[] => {
  return [
    {
      field: "nomeResponsavel",
      headerName: "Responsavel",
      flex: 1,
      minWidth: 100,
      sortable: false,
      filterable: false,
      headerClassName: "projeto-header",
    },
    {
      field: "data",
      filterable: false,
      headerName: "Data",
      width: 175,
      valueGetter: (params) => dataUtils.dataFormatada(params),
      sortable: false,
      resizable: false,
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Conteúdo",
      width: 175,
      sortable: false,
      resizable: false,
    },
    {
      field: "idProjetoRevisaoResumo",
      headerName: "Ações",
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.value, true)}>
            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
          </IconButton>
          <IconButton onClick={() => onActionDeletar(params.value, true)}>
            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
          </IconButton>
        </div>
      ),
    },
  ];
};
